var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowdown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 26a3.067 3.067 0 01-2.305-1.04L.614 10.091A2.462 2.462 0 014.312 6.84l11.439 13.003a.334.334 0 00.501 0L27.691 6.84a2.462 2.462 0 113.697 3.251L18.311 24.955A3.079 3.079 0 0116.002 26z"
  })));
}
export default SvgArrowdown;